import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditDialogComponent } from '../../../../../core/components/editDialog/editDialogComponent';
import { EditDialogInstance } from '../../../../../core/components/editDialog/editDialogService';
import { ResourceAssignment } from '../../../../shared/entities/resourceAssignment/resourceAssignment';
import { Task } from '../../../../shared/entities/task/task';
import { ControlTemplate } from '../../../form/entities/controlTemplate';

/**
 * Interface for the dialog data configuration
 */
interface ReviewFormDialogData {
  task: Task;
  template: ControlTemplate | null;
  resourceAssignments: ResourceAssignment[];
}

@Component({
  selector: 'app-review-form-dialog',
  template: `
    <div [formGroup]="reviewForm" class="form flex flex-col">
        @if (hasResourceAssignments) {
          @for (resourceAssignment of resourceAssignments; track trackByResourceAssignment($index, resourceAssignment)) {
            <app-order-rent-resourceAssignment-protocols-view
              [showReviewProtocol]="false"
              [resourceAssignment]="resourceAssignment">
            </app-order-rent-resourceAssignment-protocols-view>
          }
        }
    </div>
  `,
  styles: [`
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewFormDialogComponent implements EditDialogInstance {
  // Injected services
  readonly ref = inject(DynamicDialogRef);
  readonly config = inject(DynamicDialogConfig<ReviewFormDialogData>);

  // Static data from dialog config
  readonly resourceAssignments: ResourceAssignment[];
  readonly hasResourceAssignments: boolean;

  // Dummy form (required by EditDialogInstance interface)
  readonly reviewForm: FormGroup;

  constructor() {
    // Extract data from config
    this.resourceAssignments = this.config.data?.resourceAssignments ?? [];
    this.hasResourceAssignments = this.resourceAssignments.length > 0;
    
    // Initialize empty dummy form (no actual form controls needed)
    this.reviewForm = new FormGroup({});

    // Validate dialog data
    if (!this.config.data) {
      console.warn('[ReviewFormDialogComponent] No dialog data provided');
    }
  }

  getEditForm(): FormGroup {
    return this.reviewForm;
  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    // No form data to collect - just confirm and close
    this.ref.close({});
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  /**
   * TrackBy function for optimal rendering performance in ngFor
   */
  trackByResourceAssignment(index: number, item: ResourceAssignment): string {
    return item.id ?? `index-${index}`;
  }
}
